import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';

@Component({
  selector: 'app-vegetarian',
  templateUrl: './vegetarian.component.html',
  styleUrls: ['./vegetarian.component.scss'],
})
export class VegetarianComponent implements OnInit, OnDestroy {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;

  vegType: number;

  subscription: Subscription;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private generateShared: GenerateShared
  ) {
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (this.isDetail) {
          if (clicked && this.pageNumber === this.currentPageNumber) {
            this.generateShared.isVegeterian =
              this.vegType === 0 ? false : true;
            setTimeout(() => {
              this.generateShared.closeOverviewDetail();
            }, 100);
          }
        } else {
          if (clicked && this.pageNumber === this.currentPageNumber) {
            this.generateShared.isVegeterian =
              this.vegType === 0 ? false : true;
            setTimeout(() => {
              this.generateShared.nextPage();
            }, 100);
            // console.log('vegeterian', this.generateShared.isVegeterian)
          }
        }
      }
    );
  }

  ngOnInit() {
    if (this.isDetail) {
      this.vegType = this.generateShared.isVegeterian ? 1 : 0;
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  vegTypeSelect(vegType: number) {
    this.vegType = vegType;
    this.submitButtonShared.nextButtonClicked();
  }
}
